import Reveal from "./Reveal";
import { CONTACT_EMAIL, LINKEDIN_URL } from "../../data/pwt";
import { ArrowUpRight, Linkedin, Mail } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-36 bg-[#0A140F] text-white overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute -bottom-40 -right-40 w-[520px] h-[520px] rounded-full bg-[#1A402B] opacity-50 blur-3xl"
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="overline text-[#D8E2DC]">07 — Contact</span>
        </Reveal>

        <Reveal delay={120}>
          <h2 className="mt-8 font-serif text-5xl md:text-8xl tracking-tighter leading-[0.95]">
            Let&apos;s transform,
            <br />
            <span className="italic text-[#D8E2DC]">together.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 border-t border-white/15 pt-12">
          <Reveal>
            <div className="overline text-[#D8E2DC]">Email</div>
            <a
              data-testid="contact-email-link"
              href={`mailto:${CONTACT_EMAIL}`}
              className="mt-4 inline-flex items-center gap-3 font-serif text-2xl md:text-4xl text-white link-underline"
            >
              <Mail size={26} strokeWidth={1.5} />
              {CONTACT_EMAIL}
            </a>
          </Reveal>

          <Reveal delay={120}>
            <div className="overline text-[#D8E2DC]">LinkedIn</div>
            <a
              data-testid="contact-linkedin-link"
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-3 font-serif text-2xl md:text-4xl text-white link-underline"
            >
              <Linkedin size={26} strokeWidth={1.5} />
              PWT on LinkedIn
              <ArrowUpRight size={22} strokeWidth={1.5} />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
